import { useRBAC } from '@d5/rbac'
import { useEffect, useState } from 'react'

import { useStoresList } from '@/services'
import { useAppDispatch, setAllStores } from '@/store'

export const useStores = () => {
  const [getStores, setGetStores] = useState(false)
  const dispatch = useAppDispatch()
  const storeListAction = useStoresList({
    limit: 100,
    offset: 0,
  })

  const { hasPermission } = useRBAC()

  useEffect(() => {
    if (hasPermission?.('stores.get') && getStores) {
      storeListAction?.fetchData?.()
    }
  }, [getStores])

  useEffect(() => {
    if (storeListAction?.data) {
      dispatch(setAllStores(storeListAction.data.data || []))
    }
  }, [storeListAction?.data])

  return [setGetStores]
}
